<template>
  <div class="Productcenter">
    <div class="pagestitle clearfix">
      <span class="pageslink">
          <li><router-link class="indexicon" to="/" /></li>
          <li><router-link to="/alSoft">经典案例</router-link> > </li><li><router-link class='cur' :to="cur">{{curName}}</router-link></li>
      </span>
      <h4>
        <span>{{curName}}</span>
        <!--<img class="titleimg" :src="baseApi+'webimages/news.png'"  >-->
      </h4>
    </div>
    <div class="insidesnav clearfix">
      <router-link :class="cur === '/xuanhe' ? 'cur': ''" to="/xuanhe">宣鹤太平隧道</router-link>
      <router-link :class="cur === '/xiaohan' ? 'cur': ''" to="/xiaohan">孝汉应高速公路</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cur: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  computed: {
    curName () {
      switch (this.cur) {
        case '/xuanhe':
          return '宣鹤太平隧道机电安装'
        case '/xiaohan':
          return '孝汉应高速公路机电安装'
        default:
          return ''
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/classics/componets/Tab.vue